export enum SOrganGroup {
  Liver = 'Liver',
  HeartAndLungs = 'HeartAndLungs',
}
